// loadSentryBrowser.js

/**
 * Loads the @sentry/browser bundle on demand (only when actually needed).
 *
 * Why this one line lives in its own file:
 * This `import(...)` only belongs to the main app, not the Service Worker.
 * But the SW imports `sentry.js`, and if this line were inside `sentry.js`,
 * webpack would pull extra stuff into the SW file and make it look "new" on
 * every deploy (causing needless SW reinstalls). Keeping the line here — a
 * file the SW never imports — avoids that.
 *
 * The main app wires it up at startup:
 *   setSentryLoader(loadSentryBrowser)   // from ../index.js, before initSentry()
 *
 * @returns {Promise<object>} The `@sentry/browser` module.
 * @example
 * import { loadSentryBrowser } from '../resource/loadSentryBrowser.js';
 * import { setSentryLoader } from '../resource/sentry.js';
 * setSentryLoader(loadSentryBrowser);
 */
const loadSentryBrowser = () => import('../partial/@sentry/browser/default.js');

export { loadSentryBrowser };
